// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__GJBsH","box":"WorkspacesBox_box__1HJ2n","node":"WorkspacesBox_node__TuEVs"};